import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link, useLocation } from "react-router-dom"
import { isEmpty, set } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import cellEditFactory from "react-bootstrap-table2-editor"
import * as Yup from "yup"
import { useFormik } from "formik"

// import DeleteModal from "../../../components/Common/DeleteModal";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import * as moment from "moment"

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Table,
  CardTitle,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import {
  getEmployees as onGetEmployees,
  addNewEmployee as onAddNewEmployee,
  updateEmployee as onUpdateEmployee,
  deleteEmployee as onDeleteEmployee,
  getAuthUsers as onGetAuthUser,
  updateCustomerField,
} from "store/actions"

import EmployeesEmployeesModal from "./employeeModal"
import Columns from "./Columns"
import { expandRow } from "./employeeDetails"

const Employees = props => {


    //meta title
    document.title = "Invoice Detail | Skote - React Admin & Dashboard Template";
   
  const dispatch = useDispatch()

  const [employeeList, setEmployeeList] = useState([])
  const [employee, setEmployee] = useState(null)

  // validation
  // const validation = useFormik({
  //   // enableReinitialize : use this flag when initial values needs to be changed
  //   enableReinitialize: true,

  //   initialValues: {
  //     employeeId: (employee && employee.employeeId) || "",
  //     billingName: (employee && employee.billingName) || "",
  //     employeedate: (employee && employee.employeedate) || "",
  //     total: (employee && employee.total) || "",
  //     paymentStatus: (employee && employee.paymentStatus) || "Paid",
  //     badgeclass: (employee && employee.badgeclass) || "success",
  //     paymentMethod: (employee && employee.paymentMethod) || "Mastercard",
  //   },
  //   validationSchema: Yup.object({
  //     employeeId: Yup.string().required("Please Enter Your Employee Id"),
  //     billingName: Yup.string().required("Please Enter Your Billing Name"),
  //     employeedate: Yup.string().required("Please Enter Your Employee Date"),
  //     total: Yup.string().required("Total Amount"),
  //     paymentStatus: Yup.string().required("Please Enter Your Payment Status"),
  //     badgeclass: Yup.string().required("Please Enter Your Badge Class"),
  //     paymentMethod: Yup.string().required("Please Enter Your Payment Method"),
  //   }),
  //   onSubmit: values => {
  //     if (isEdit) {
  //       const updateEmployee = {
  //         id: employee ? employee.id : 0,
  //         employeeId: values.employeeId,
  //         billingName: values.billingName,
  //         employeedate: values.employeedate,
  //         total: values.total,
  //         paymentStatus: values.paymentStatus,
  //         paymentMethod: values.paymentMethod,
  //         badgeclass: values.badgeclass,
  //       }
  //       dispatch(onUpdateEmployee(updateEmployee))
  //       validation.resetForm()
  //     } else {
  //       const newEmployee = {
  //         id: Math.floor(Math.random() * (30 - 20)) + 20,
  //         employeeId: values["employeeId"],
  //         billingName: values["billingName"],
  //         employeedate: values["employeedate"],
  //         total: values["total"],
  //         paymentStatus: values["paymentStatus"],
  //         paymentMethod: values["paymentMethod"],
  //         badgeclass: values["badgeclass"],
  //       }
  //       dispatch(onAddNewEmployee(newEmployee))
  //       validation.resetForm()
  //     }
  //     toggle()
  //   },
  // })

  const { employees, designerUsers } = useSelector(state => ({
    employees: state.Employees.employees,
    designerUsers: state.Employees.employees
  }))

  const selectRow = {
    mode: "checkbox",
  }

  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isRight, setIsRight] = useState(false)
  const [designers, setDesigners] = useState({})
  
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: 50,
    custom: true,
  })
  
  const handleTableChange = (type, { page, sizePerPage }) => {
    let json = {params:{ Designation: { $in: ["User", "Administrate", "sales", "designer"]}}, paginate:{ size: 50, page: page }}
    dispatch(onGetEmployees(json))
  }

  //pagination customization
  // const pageOptions = 

  const { SearchBar } = Search

  // const toggleModal = () => {
  //   setModal1(!modal1)
  // }

  const toggleViewModal = () => setModal1(!modal1)

  const toLowerCase1 = str => {
    return str === "" || str === undefined ? "" : str.toLowerCase()
  }

  useEffect(() => {
    if (!employees.hasOwnProperty("docs")) {
      let json = {params: { Designation: { $in: ["Administrate", "sales", "designer"]}}, paginate:{ size: 50, page: 1 }}
      dispatch(onGetEmployees(json))
    }
  }, [dispatch, employees])

  useEffect(() => {
    if (!designerUsers.hasOwnProperty("docs")) {
      dispatch(onGetAuthUser())
    }
    setDesigners(designerUsers);
  }, [ designerUsers])
  

  useEffect(() => {
    setEmployeeList(employees)
    setPageOptions({
      sizePerPage: employees.limit,
      page: employees.offset,
      totalSize: employees.totalDocs,
      custom: true,
    })
  }, [employees])

  useEffect(() => {

    if (!isEmpty(employees) && !!isEdit) {
      setEmployeeList(employees)
      setIsEdit(false)
    }
  }, [employees])



  const toggle = () => {
    if (modal) {
      setModal(false)
      setEmployee(null)
    } else {
      setModal(true)
    }
  }

  const handleEmployeeClick = arg => {
    const employee = arg

    setEmployee({
      id: employee.id,
      employeeId: employee.employeeId,
      billingName: employee.billingName,
      employeedate: employee.employeedate,
      total: employee.total,
      paymentStatus: employee.paymentStatus,
      paymentMethod: employee.paymentMethod,
      badgeclass: employee.badgeclass,
    })

    setIsEdit(true)

    toggle()
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  //delete employee
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = employee => {
    dispatch(onDeleteEmployee(employee._id))
  }


  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const toggleRightCanvas = () => {
    setIsRight(!isRight)
  }

  const defaultSorted = [
    {
      dataField: "employeeId",
      employee: "desc",
    },
  ]
  const handleChange = (oldValue, newValue, row, column, done) => {
    dispatch(updateCustomerField({[column.dataField]:newValue, _id: row._id}))

  }

  return (
    <React.Fragment>
      {/* <OffCanvasModel isRight={isRight} toggleRightCanvas={toggleRightCanvas} /> */}
      <EmployeesEmployeesModal isOpen={modal1} toggle={toggleViewModal} />
      {/* <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteEmployee}
        onCloseClick={() => setDeleteModal(false)}
      /> */}
      <div className="page-content">
        <MetaTags>
          <title>Employees</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Employees" breadcrumbItem="Employees" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="_id"
                    columns={Columns(
                      toggle,
                      handleValidDate,
                      handleEmployeeClick,
                      onClickDelete,
                      toLowerCase1,
                      toggleViewModal,
                      designers
                    )}
                    data={employees.hasOwnProperty("docs") ? employees.docs : employees}
                    // cellEdit={ cellEditFactory({ mode: 'click' }) }
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="_id"
                        data={
                          employees.hasOwnProperty("docs") ? employees.docs : employees
                        }
                        columns={Columns(
                          toggle,
                          handleValidDate,
                          handleEmployeeClick,
                          onClickDelete,
                          toLowerCase1,
                          toggleViewModal,
                          designers
                        )}
                        bootstrap4
                        search
                        // cellEdit={ cellEditFactory({ mode: 'click' }) }
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="4">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                             
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={ {
                                      filter: true,
                                      pagination: true,
                                      sort: false,
                                      cellEdit: false
                                    } }
                                    keyField="_id"
                                    responsive
                                    bemployeeed={false}
                                    striped={false}
                                    // defaultSorted={defaultSorted}
                                    classes={"table align-middle table-nowrap table-check"}
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    onTableChange={ handleTableChange  }
                                    cellEdit={cellEditFactory({
                                      mode: "dbclick",
                                      blurToSave: true,
                                      afterSaveCell: handleChange
                                    })}
                                    ref={node}
                                  />
                                </div>
                               
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
     

    </React.Fragment>
  )
}

Employees.propTypes = {
  employees: PropTypes.array,
  onGetEmployees: PropTypes.func,
  onAddNewEmployee: PropTypes.func,
  onDeleteEmployee: PropTypes.func,
  onUpdateEmployee: PropTypes.func,
}

export default withRouter(Employees)
